import React, { useCallback } from 'react'

import { AIGenerated, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'
import { PLAN_ANNUAL } from 'Pods/SubscriptionCheckout/Constants/plans'

import { quoteShape } from '../../propTypes'

const TRANSLATION_KEY_PREFIX = 'subscription_upgrade.explainer'
const RESTRUCTURE_KEY_PREFIX = 'subscription_checkout.plans_restructure.upgrade.banner'

function leadKeyFor({ current, targetPlan }) {
  if (current.tier === targetPlan.tier) return `lead_switch_to_annual.${current.tier}`
  return current.planType === PLAN_ANNUAL ? 'lead_upgrade_from_annual' : 'lead_upgrade'
}

function ExplainerBanner({
  downloadsUsed = 0, unusedCredits = 0, quote = null, locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const icon = (
    <span className="upgrade-explainer__icon" aria-hidden="true">
      <Icon svgComponent={AIGenerated} color="primary" size="small" notSpaced />
    </span>
  )

  if (quote) {
    const { used, total } = quote.units
    const period = quote.credit.planType === PLAN_ANNUAL ? 'period_annual' : 'period_month'

    return (
      <div className="upgrade-explainer">
        {icon}
        <p className="upgrade-explainer__text cgt-body-base">
          {translate(`${RESTRUCTURE_KEY_PREFIX}.${leadKeyFor(quote)}`)}{' '}
          {translate(`${RESTRUCTURE_KEY_PREFIX}.used_prefix`)}{' '}
          <strong>{translate(`${RESTRUCTURE_KEY_PREFIX}.used_of_total`, { used, total })}</strong>{' '}
          {translate(`${RESTRUCTURE_KEY_PREFIX}.${period}`)}{' '}
          <strong>{translate(`${RESTRUCTURE_KEY_PREFIX}.unused`, { unused: total - used })}</strong>{' '}
          {translate(`${RESTRUCTURE_KEY_PREFIX}.suffix`)}
          {quote.targetPlan.planType === PLAN_ANNUAL && <>{' '}{translate(`${RESTRUCTURE_KEY_PREFIX}.new_term`)}</>}
        </p>
      </div>
    )
  }

  const limit = downloadsUsed + unusedCredits

  return (
    <div className="upgrade-explainer">
      {icon}
      <p className="upgrade-explainer__text cgt-body-base">
        {translate(`${TRANSLATION_KEY_PREFIX}.prefix`)}{' '}
        <strong>{translate(`${TRANSLATION_KEY_PREFIX}.used_of_limit`, { used: downloadsUsed, limit })}</strong>{' '}
        {translate(`${TRANSLATION_KEY_PREFIX}.middle`)}{' '}
        <strong>{translate(`${TRANSLATION_KEY_PREFIX}.unused`, { unused: unusedCredits })}</strong>{' '}
        {translate(`${TRANSLATION_KEY_PREFIX}.suffix`)}
      </p>
    </div>
  )
}

ExplainerBanner.propTypes = {
  downloadsUsed: number,
  unusedCredits: number,
  quote: quoteShape,
  locale: string,
}

export default ExplainerBanner
